<template>
  <div v-if="invoice">
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span :class="['px-4 py-1 rounded-lg font-bold text-xs absolute top-4 right-4', invoiceStatus]">
        {{ $t(`${invoice.approvalStatus}`) }}
      </span>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
        <StackedField label="Facture">
          <div class="inline-flex items-center bg-white rounded-sm p-2 border border-gray-200">
            <PaperClipIcon class="shrink-0 h-3 w-3 text-gray-400 mr-1" />
            <span class="text-xs text-gray-900 mr-2 max-w-xs truncate">{{ invoice.fileName }}</span>
            <a
              :href="invoice.url"
              target="_blank"
              rel="noopener noreferrer"
              class="shrink-0 p-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-sm transition-colors duration-200"
            >
              <EyeIcon class="h-3 w-3" />
            </a>
          </div>
        </StackedField>
        <StackedField label="Montant" :value="formatPrice(invoice.repairCost)" />
      </div>
      <button
        class="font-light text-primary hover:text-primary-dark cursor-pointer mt-2"
        @click="openInvoiceCostDetails = true"
      >
        Voir les détails
      </button>
      <InvoiceCostDetails :invoice="invoice" :open="openInvoiceCostDetails" @close="openInvoiceCostDetails = false" />
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { EyeIcon, PaperClipIcon } from "@heroicons/vue/solid";
import InvoiceCostDetails from "@/components/claim/details/invoice/InvoiceCostDetails.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    StackedField,
    InvoiceCostDetails,
    PaperClipIcon,
    EyeIcon,
  },
  props: ["invoice"],

  data() {
    return {
      openInvoiceCostDetails: false,
    };
  },

  computed: {
    ...mapGetters("claims", ["invoiceStatusClass"]),
    invoiceStatus() {
      return this.invoiceStatusClass(this.invoice.approvalStatus);
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
